module.exports = "/_next/static/branding.png";